import './App.css';

import { Helmet } from 'react-helmet';

import LandingPage from './unAuth/LandingPage';

function App() {
  return (
    <div className="App">
      <Helmet>
        <meta
          name="description"
          content="Generate AI-powered YouTube timestamps and previews instantly with TubeStamp."
        />
        <meta property="og:title" content="TubeStamp" />
        <meta
          property="og:description"
          content="Create and share polished YouTube timestamps in seconds."
        />
      </Helmet>
      <div className="app-container">
        <LandingPage />
      </div>
    </div>
  );
}

export default App;
